import * as actionTypes from "./actionTypes";
import axios from "./../../axios-api";

export const fetchDivisions = (lang) => {
  const langArray = JSON.parse(import.meta.env.CLIENT_REACT_APP_LANGUAGE);
  let OriginLanguage = langArray.includes(lang) ? lang : "en-gb";

  return (dispatch) => {
    dispatch(fetchDivisionsStart());
    axios
      .get(`/Divisions/${OriginLanguage}`)
      .then((response) => {
        dispatch(fetchDivisionsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(fetchDivisionsFail(err));
      });
  };
};

/***********************************************************
 // Fetch All Divisions
 ***********************************************************/
export const fetchDivisionsStart = () => {
  return {
    type: actionTypes.FETCH_DIVISIONS_START,
  };
};

export const fetchDivisionsSuccess = (data) => {
  return {
    data: data,
    type: actionTypes.FETCH_DIVISIONS_SUCCESS,
  };
};

export const fetchDivisionsFail = (error) => {
  return {
    type: actionTypes.FETCH_DIVISIONS_FAIL,
    error: error,
  };
};
